import { render, staticRenderFns } from "./AlertDelivery.vue?vue&type=template&id=1872f9b4&lang=pug&"
import script from "./AlertDelivery.vue?vue&type=script&lang=js&"
export * from "./AlertDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports